import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    TgButtons2Module,
    TgGridModule,
    TgInputGroupModule,
    TgInputModule,
    TgLoadingModule
} from '@trademe/tangram';
import { PropertyVideoSectionComponent } from './property-video-section.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgGridModule,
        TgInputModule,
        TgInputGroupModule,
        TgButtons2Module,
        TgLoadingModule
    ],
    declarations: [PropertyVideoSectionComponent],
    exports: [PropertyVideoSectionComponent]
})
export class PropertyVideoSectionModule {}
